import { Component, OnInit } from "@angular/core";

@Component({
  selector: "lib-ui-notification",
  template: ` <p>ui-notification works!</p> `,
  styles: [],
})
export class UiNotificationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
